module.exports = __webpack_public_path__ + "img/20_81.a0e8f80a.png";